import CustomForm from "../CustomForm";
import {ValidationError} from "../ICustomForm";
import ICustomFormSettings from "../ICustomFormSettings";
import {loadJsonFromString} from "../shared/helpers";
import {CellItem} from "../../model/items/cellItem";
import {RadioItem} from "../../model/items/radio";

export default abstract class RadioList extends CustomForm {

    protected errorMessage: string|null = null;

    protected autoSubmitNextForm = false;
    protected isSubmitting = false;

    public rewriteFormControls() {
        return true;
    }

    constructor(settings: ICustomFormSettings) {
        super(settings);

        loadJsonFromString(settings.form.aux1?.toLowerCase(), settings.form.questionary, (data) => {
            this.autoSubmitNextForm = Boolean(data?.['autosubmitnextform']);
        });
    }

    protected onSetValue(cellItem: CellItem, value: any) {
        if (!this.isSubmitting) {
            super.onSetValue(cellItem, value);
            if (this.autoSubmitNextForm && cellItem instanceof RadioItem && this.settings.form.validate()) {
                this.isSubmitting = true;
                setTimeout(() => this.settings.nextForm(), 350);
            }
        }
    }

    public onValidationErrors(errors: ValidationError[]): void {
        this.errorMessage = this.settings.app.messages.get('validateMessage');
    }
}
